query getAIMarketInsights($compact: Boolean) {
  getAIMarketInsights(compact: $compact)
}